<template>
	<div class="overallBackground">
		<div class="loginBox">
			<div class="signIn">
				<img src="../assets/image/registrationBackground.png" alt="" />
			</div>
			<div class="loginContent">
				<div class="mainImage">
					<img src="../assets/image/mainImage.png" alt="" />
				</div>
				<div class="welcome">
					<img src="../assets/image/registrationChart.png" alt="" />
				</div>
				<div class="layoutContent">
					<div class="individualContent">
						<div class="title">姓名</div>
						<div class="inputBox">
							<input type="text" placeholder="请输入您的姓名" v-model="realName" />
						</div>
					</div>
					<div class="individualContent">
						<div class="title">手机号</div>
						<div class="inputBox">
							<input type="text" maxlength="11" placeholder="请输入您的手机号" v-model="phone" />
							<!-- <div class="inputBox"
								style="display: flex;align-items: center;justify-content: space-between;">
								<input type="text" placeholder="请输入验证码" v-model="code">
								<div class="verificationCode" @click="getCode()">
									{{codeBtnWord}}
								</div>
							</div> -->
						</div>
					</div>
				</div>
				<div class="layoutContent">
					<div class="individualContent">
						<div class="title">验证码</div>
						<div class="inputBox" style="display: flex;align-items: center;justify-content: space-between;">
							<input type="text" placeholder="请输入验证码" v-model="code">
							<div class="verificationCode" @click="getCode()">
								{{codeBtnWord}}
							</div>
						</div>
					</div>
					<div class="individualContent">
						<div class="title">地址</div>
						<div class="inputBox">
							<el-cascader style="width: 100%;" placeholder="省/市/区" v-model="values"
								:props="{value:'label'}" :options="options" @change="handleChange"></el-cascader>
							<!-- <cascader @provincesValueChang="provincesValueChang"
								:value="[form.province, form.city, form.area]" @update:value="form.region = $event"
								style="width: 100%"></cascader> -->
						</div>
					</div>

				</div>
				<div class="layoutContent">
					<div class="individualContent">
						<div class="title">详细地址</div>
						<div class="inputBox">
							<input type="text" placeholder="请输入您的详细地址" v-model="addressDetails" />
						</div>
					</div>
					<div class="individualContent">
						<div class="title">性别</div>
						<div class="inputBox" style="display: flex;align-items: center;">
							<div class="ualGoals">
								<img src="../assets/icon/choice.png" alt="" v-if="gender==0" />
								<img src="../assets/icon/unchecked.png" alt="" v-else @click="genderSwitching(0)" />
								<div>女</div>
							</div>
							<div class="ualGoals">
								<img src="../assets/icon/choice.png" alt="" v-if="gender==1" />
								<img src="../assets/icon/unchecked.png" alt="" v-else @click="genderSwitching(1)" />
								<div>男</div>
							</div>
						</div>
					</div>

				</div>
				<div class="layoutContent" style="align-items: baseline;">
					<div class="individualContent">
						<div class="title">出生日期</div>
						<div class="inputBox">

							<el-date-picker v-model="birthday" type="date" placeholder="选择日期" format="yyyy 年 MM 月 dd 日"
								value-format="yyyy-MM-dd" @change="dateSelection">
							</el-date-picker>
							<!-- <input type="number" placeholder="请输入您的年龄" style="background: #FBF4EB;" /> -->
						</div>
					</div>
					<div class="idse">
						<div class="titleOfIdCard">上传您的身份证件<span>请上传身份证正反面照片</span></div>
						<div class="singleIdCard">
							<div>
								<!-- <img src="../assets/icon/frontOfIDCard.png" alt="" /> -->
								<el-upload class="avatar-uploader" ref="AvatarUpload" :action="action"
									:show-file-list="true" :limit='1' list-type="picture-card"
									:on-success="uploadFileportraitFace" :on-remove="handleRemoveportraitFace"
									style="width: 156px;height: 98px;" :headers="{token: token}">
									<img src="../assets/icon/frontOfIDCard.png" alt=""
										style="width: 156px;height: 98px;" v-if="cardBack==''" />
									<img :src="cardBack" alt="" style="width: 156px;height: 98px;"
										v-if="cardBack!=''" />
								</el-upload>
							</div>
							<div style="margin-left: 10px;">
								<el-upload class="avatar-uploader" ref="lEmblemFace" :action="action"
									:show-file-list="true" :limit='1' list-type="picture-card"
									:on-success="uploadFilenationalEmblemFace"
									:on-remove="handleRemovenationalEmblemFace" style="width: 156px;height: 98px;"
									:headers="{token: token}">
									<img src="../assets/icon/onTheBackOfTheIDCard.png" alt=""
										style="width: 156px;height: 98px;" v-if='cardFront==""' />
									<img :src="cardFront" alt="" style="width: 156px;height: 98px;"
										v-if="cardFront!=''" />
								</el-upload>
							</div>
						</div>
					</div>
				</div>
				<div class="submitForReview" @click="submitForReview">提交审核</div>
				<div class="existingAccount">已有账号？<span @click="jumpTo('/login')">立即登录</span></div>
				<div class="agreement">
					<img src="../assets/icon/unchecked.png" alt="" v-if="doYouWantToChoose==false"
						@click="switchSelection" />
					<img src="../assets/icon/choice.png" alt="" v-else @click="switchSelection" />
					<div>注册代表同意<span @click='jumpTo("/agreement",1)'>《用户服务协议》</span>与<span
							@click='jumpTo("/agreement",2)'>《隐私政策》</span></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import cascader from "@/components/cascader";
	import {
		baseURL
	} from "@/api/index";
	import {
		register,
		sendCode
	} from "@/api/api.js"
	import {
		regionData
	} from 'element-china-area-data'
	export default {
		data() {
			return {
				action: baseURL + "/common/upload",
				gender: 0,
				doYouWantToChoose: false,
				form: {},
				realName: "",
				phone: '',
				address: '',
				addressDetails: '',
				birthday: '',
				cardBack: '',
				cardFront: '',
				token: localStorage.getItem('token'),
				options: regionData,
				values: '',
				code: '',
				codeBtnWord: '获取验证码', // 获取验证码按钮文字
				waitTime: 60, // 获取验证码按钮失效时间
				getCodeBtnDisable: false,
			}
		},
		components: {
			cascader,
		},
		methods: {
			getCode() {
				if (this.phone == '') {
					this.$message.error('请输入手机号');
					return
				}
				let reg = /^1[3456789]\d{9}$/
				if (!reg.test(this.phone)) {
					this.$message.error('手机号格式不正确');
					return
				}
				if (this.getCodeBtnDisable == false) {
					sendCode({
						phone: this.phone,
						isRegister: 1
					}).then(res => {
						if (res.code == 200) {
							this.$message.success('验证码发送成功')
							let that = this
							that.waitTime--
							that.getCodeBtnDisable = true
							this.codeBtnWord = `${this.waitTime}s 后重新发送`
							let timer = setInterval(function() {
								if (that.waitTime > 1) {
									that.waitTime--
									that.codeBtnWord = `${that.waitTime}s 后重新发送`
								} else {
									clearInterval(timer)
									that.codeBtnWord = '获取验证码'
									that.getCodeBtnDisable = false
									that.waitTime = 60
								}
							}, 1000)
						} else {
							this.$message.error(res.msg);
							return
						}
					})

				} else {
					this.$message.error('请勿重复点击');
				}



			},
			submitForReview() {
				if (this.realName == '') {
					this.$message.error('请输入姓名');
					return
				}
				if (this.phone == '') {
					this.$message.error('请输入手机号');
					return
				}
				const regex = /^1[3-9]\d{9}$/;
				if (!regex.test(this.phone)) {
					this.$message.error('手机号格式不正确');
					return
				}
				if (this.address == '') {
					this.$message.error('请输入验证码验证码');
					return
				}
				if (this.address == '') {
					this.$message.error('请选择省市区');
					return
				}
				if (this.addressDetails == '') {
					this.$message.error('请输入详细地址');
					return
				}
				if (this.birthday == '') {
					this.$message.error('请选择出生日期');
					return
				}
				if (this.cardBack == '') {
					this.$message.error('请上传身份证人像面');
					return
				}
				if (this.cardFront == '') {
					this.$message.error('请上传身份证国徽面');
					return
				}
				if (this.doYouWantToChoose == false) {
					this.$message.error('请阅读并勾选《用户服务协议》与《隐私政策》');
					return
				}
				register({
					realName: this.realName,
					phone: this.phone,
					address: this.address,
					addressDetails: this.addressDetails,
					gender: this.gender,
					birthday: this.birthday,
					cardBack: this.cardBack,
					cardFront: this.cardFront,
					code: this.code
				}).then(res => {
					if (res.code == 200) {
						this.$message({
							message: res.msg,
							type: 'success'
						});
						localStorage.setItem('token', res.data)
						setTimeout(() => {
							this.$router.push({
								path: '/index/home'
							})
						}, 1000);
					} else {
						this.$message.error(res.msg);
					}
					console.log(res, '2222222');
				})
			},
			//人像面
			uploadFileportraitFace(res, fileList) {
				console.log(res)
				this.cardBack = res.url
				this.$refs.AvatarUpload.$children[1].$el.style.display = 'none'
			},
			handleRemoveportraitFace(file, fileList) {
				this.cardBack = ''
				this.$refs.AvatarUpload.$children[1].$el.style.display = ''
			},
			//国徽面
			uploadFilenationalEmblemFace(res, fileList) {
				this.cardFront = res.url
				this.$refs.lEmblemFace.$children[1].$el.style.display = 'none'
			},
			handleRemovenationalEmblemFace(file, fileList) {
				this.cardFront = ''
				this.$refs.lEmblemFace.$children[1].$el.style.display = ''
			},
			//日期选择
			dateSelection(e) {
				this.birthday = e
				console.log(e)
			},
			// 省市区
			handleChange(value) {
				this.address = value[0] + '-' + value[1] + '-' + value[2]
				this.values = value
				console.log(value)
			},


			switchSelection() {
				this.doYouWantToChoose = !this.doYouWantToChoose
			},
			genderSwitching(i) {
				this.gender = i
			},
			jumpTo(url, i) {
				this.$router.push({
					path: url,
					query: {
						type: i
					}
				}).catch(() => {})
			}
		}
	}
</script>

<style lang="scss" scoped>
	::v-deep .el-upload-list__item-status-label {
		display: none !important;
	}

	::v-deep .el-upload-list--picture-card {
		display: flex;
		width: 330px;
	}

	::v-deep .el-upload--picture-card {
		width: 156px;
		height: 98px;
		line-height: normal;
		border: none;
	}

	::v-deep .el-upload-list--picture-card .el-upload-list__item {
		width: 156px;
		height: 98px;
	}

	.overallBackground {
		width: 100%;
		height: 100vh;
		background-image: url('../assets/image/loginBackground.png');
		background-size: cover;
		/* 或者其他你需要的大小设置 */
		background-position: center;
		/* 背景图片居中 */
		background-repeat: no-repeat;
		/* 背景图片不重复 */
	}

	.submitForReview {
		width: 437px;
		height: 50px;
		background: linear-gradient(90deg, #ECBF85 0%, #D89A3A 100%);
		border-radius: 30px 30px 30px 30px;
		font-family: PingFang SC, PingFang SC;
		font-weight: bold;
		font-size: 20px;
		color: #FFFFFF;
		text-align: center;
		line-height: 50px;
		margin: 0 auto;
		margin-top: 10px;
		cursor: default;
	}

	.existingAccount {
		font-family: PingFang SC, PingFang SC;
		font-weight: 500;
		font-size: 16px;
		color: #777777;
		text-align: center;
		margin-top: 15px;

		span {
			color: #D89A3A;
			cursor: default;
		}
	}

	.agreement {
		display: flex;
		align-items: center;
		margin: 0 auto;
		margin-top: 42px;
		text-align: center;
		justify-content: center;

		img {
			width: 16px;
			height: 16px;
		}

		div {
			margin-left: 8px;
			font-family: PingFang SC, PingFang SC;
			font-weight: 500;
			font-size: 14px;
			color: #777777;
			cursor: default;

			span {
				color: #663300;
			}
		}
	}

	.loginBox {
		position: relative;
		top: 100px;
		left: 50%;
		right: 0;
		width: 851px;
		height: 700px;

		.signIn {
			width: 851px;
			height: 700px;

			img {
				width: 851px;
				height: 700px;

			}
		}
	}

	.loginContent {
		position: absolute;
		top: 20px;
		left: 80px;
		right: 80px;

		.mainImage {
			width: 150px;
			height: 67.35px;
			margin: 0 auto;

			img {
				width: 150px;
				height: 67.35px;
			}
		}

		.welcome {
			width: 155px;
			height: 35px;
			margin: 15px auto;

			img {
				width: 155px;
				height: 35px;
			}
		}

		.layoutContent {
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin-top: 10px;

			.individualContent {
				width: 40%;

				.title {
					font-family: PingFang SC, PingFang SC;
					font-weight: bold;
					font-size: 16px;
					color: #333333;
				}

				.inputBox {
					padding: 10px 0;
					border-bottom: 1px solid #E6E6E6;

					.ualGoals {
						display: flex;
						align-items: center;
						margin-right: 40px;

						img {
							margin-right: 10px;
							width: 15px;
							height: 15px;
						}
					}

					.verificationCode {
						font-family: PingFang SC, PingFang SC;
						font-weight: 500;
						font-size: 16px;
						color: #DF632B;
					}

					input {
						border: none;
						outline: none;
						box-shadow: none;
						font-family: PingFang SC, PingFang SC;
						font-weight: 500;
						font-size: 14px;
						color: #333;
						background: #FEF9F3;
					}
				}
			}
		}

		.idse {
			margin-top: 10px;

			.titleOfIdCard {
				font-family: PingFang SC, PingFang SC;
				font-weight: bold;
				font-size: 16px;
				color: #333333;

				span {
					font-family: Source Han Sans CN, Source Han Sans CN;
					font-weight: 400;
					font-size: 13px;
					color: #ADAFB7;
					margin-left: 10px;
				}
			}

			.singleIdCard {
				display: flex;
				align-items: center;
				margin-top: 10px;

				div {
					width: 156px;
					height: 98px;

					img {
						width: 156px;
						height: 98px;
					}
				}
			}
		}
	}
</style>